<template>
  <div>
    <dl class="change-payment-mode">
      <dt class="change-payment-mode__title">Оплачено (сумма)</dt>
      <dd class="change-payment-mode__value">{{ totalPaid }}</dd>
    </dl>
    <form
      class="form-change-payment-mode"
      v-on:submit.prevent="onSubmit"
    >
      <input-radio-with-bullets
        class="form-change-payment-mode__modes"
        identifier="change-payment-mode-radio"
        v-bind:items="modeOptions"
        v-model="mode" />
      <button
        class="form-change-payment-mode__cancel"
        type="button"
        v-on:click="onCancel"
      >Отмена</button>
      <button
        class="form-change-payment-mode__submit"
        type="submit"
        v-bind:disabled="isSubmitButtonDisabled"
      >Ок</button>
    </form>
  </div>
</template>

<script>
import InputRadioWithBullets from '@/components/InputRadioWithBullets.vue';

/**
 * @description Компонент формы изменения способа оплаты.
 * @type {Vue}
 */
export default {
  components: { InputRadioWithBullets },
  computed: {
    isSubmitButtonDisabled() {
      return this.mode === null;
    },
  },
  data() {
    return {
      mode: this.initialMode,
    };
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onSubmit() {
      this.$emit('submit', this.mode);
    },
  },
  props: {
    initialMode: { default: null, type: String },
    modeOptions: { required: true, type: Array },
    totalPaid: { required: true, type: String },
  },
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";

.change-payment-mode {
  & &__title::after {
    content: ":";
  }
  & &__title,
  & &__value {
    color: var(--reading-color);
    display: inline;
  }
  & &__title + &__value {
    margin-left: 3rem;
  }
}

.form-change-payment-mode {
  display: grid;
  grid: "modes modes" ". ."/ 1fr 1fr;
  grid-gap: 1rem;
  margin-top: 1.5rem;
  & &__modes {
    color: var(--reading-color);
    grid-area: modes;
  }
  & &__submit {
    @include buttons.btn-blue(100%, 3rem, 1rem);
    min-width: 100px;
  }
  & &__submit:disabled {
    background-color: var(--unfocus-color);
    border: 1px solid var(--unfocus-color);
    color: var(--primary-background-color);
  }
  & &__cancel {
    @include buttons.btn-transparent(100%, 3rem, 1rem);
    min-width: 100px;
  }
}
</style>
